const Footer = () => {
    return ( <>
        <p className="footer-login-box">
            Developed By: CTS - All Rights Reserved - {process.env.REACT_APP_BUILD_VERSION}
        </p>
    </> );
}
 
export default Footer;